import { AfterViewInit, Directive, ElementRef, inject, OnDestroy } from '@angular/core';

const SCROLL_VISIBLE_CLASS = 'has-scroll';

@Directive({
  selector: '[appScrollVisible]',
  standalone: true,
})
export class ScrollVisibleDirective implements AfterViewInit, OnDestroy {
  private readonly el = inject(ElementRef<HTMLElement>);
  private resizeObserver: ResizeObserver | null = null;
  private rafId: number | null = null;
  private lastHasScroll: boolean | null = null;

  ngAfterViewInit(): void {
    this.initResizeObserver();
  }

  ngOnDestroy(): void {
    this.teardown();
  }

  private initResizeObserver(): void {
    this.scheduleCheck();
    this.resizeObserver = new ResizeObserver(() => this.scheduleCheck());
    this.resizeObserver.observe(this.el.nativeElement);
  }

  private teardown(): void {
    if (this.rafId !== null) cancelAnimationFrame(this.rafId);
    this.resizeObserver?.disconnect();
  }

  private scheduleCheck(): void {
    if (this.rafId !== null) return;
    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;
      this.checkScroll();
    });
  }

  private checkScroll(): void {
    const { nativeElement } = this.el;
    const hasScroll = nativeElement.scrollHeight > nativeElement.clientHeight;
    if (this.lastHasScroll === hasScroll) return;
    this.lastHasScroll = hasScroll;
    nativeElement.classList.toggle(SCROLL_VISIBLE_CLASS, hasScroll);
  }
}
